import React from 'react';
import cl from "./EducationList.module.css";
import EducationCase from "./EducationCase/EducationCase";
import { Course } from '../../../api/api';

interface EducationListProps {
    courses: Course[];
}

const EducationList: React.FC<EducationListProps> = ({ courses }) => {

    return (
        <div className={cl.eruditCoursesGrid}>
            {courses.map((item, index) => (
                <EducationCase key={index} item={item}/>
            ))}
        </div>
    );
};

export default EducationList;